import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 15l-3 -3l3 -3","key":"svg-0"}],["path",{"d":"M11 15l-3 -3l3 -3","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}]]

const IconCircleChevronsLeft = createReactComponent('outline', 'circle-chevrons-left', 'CircleChevronsLeft', __iconNode);

export default IconCircleChevronsLeft;